<template>
    <div id="Section-03" class="section-03 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs wsl-relative"
                 :style="{backgroundImage: `url(${s03Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="cb-bg-blue block-header wsl-p-y-10 wsl-hide-md">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">03</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Бронирование туров</div>
                    </div>
                </div>

                <div class="cb-bg-blue block-header wsl-p-y-10 wsl-hide-sm wsl-hide-xs wsl-inline-block">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">03</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Бронирование туров</div>
                    </div>
                </div>

                <div class="wsl-show-sm wsl-show-xs wsl-p-a-15" style="
                    background-color: #fff;">
                    <div class="wsl-flex-middle-ng">
                        <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                            <div>
                                <span class="Oswald-Light cb-cyan t30">Высокотехнологичная </span>
                                <span class="Oswald-Light cb-blue t30">система бронирования туров</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-35 wsl-hide-sm wsl-hide-xs"></div>

                <div class="wsl-flex-column-ng wsl-p-y-40">
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 cb-bg-blue"
                    >Моментальные автоматические оплаты туроператорам
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8"><span
                            class="cb-blue">100%</span> актуальность результатов с временем вылета и сборами
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">Поиск по
                        более чем <span class="cb-blue">200</span> туроператорам с понятным интерфейсом
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">
                        Интернет-эквайринг с рекордно низкой ставкой, в том числе с оплатой от заказчика
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">Единая
                        бонусная программа для всех туроператоров
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">Онлайн
                        доступ к заявкам на сайте ТО с момента бронирования
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">
                        Максимальные комиссии независимо от объемов продаж
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">
                        Бронирование в режиме <span class="cb-blue">24/7</span> в одном личном кабинете
                    </div>
                    <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8">
                        Электронный документооброт и самостоятельная автоматизированная выписка документов на вылет
                        агентством
                    </div>
                    <div class="wsl-text-center wsl-p-x-40 wsl-p-b-5 wsl-m-t-20">
                        <a class="cb-btn-blue" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-relative wsl-show-md"
                 :style="{backgroundImage: `url(${s03Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s03Bg2}`}"
                     style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top right;
                    top: 0; left: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 16.45%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">03
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-10">Бронирование туров</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s03Bg3}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 21.73%; left: 3.15%; width: 33.4%; height: 65.5%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-30" style="line-height: 1.2; padding-left: 9.15%;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Высокотехнологичная </span>
                                <span class="Oswald-Light cb-blue t36">система бронирования туров</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-flex-middle-ng wsl-p-y-50" style="padding-left: 40%;">
                    <div class="">
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10 cb-bg-blue"
                        >Моментальные автоматические оплаты туроператорам
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10"><span
                                class="cb-blue">100%</span> актуальность результатов с временем вылета и сборами
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">Поиск по
                            более чем <span class="cb-blue">200</span> туроператорам с понятным интерфейсом
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">
                            Интернет-эквайринг с рекордно низкой ставкой, в том числе с оплатой от заказчика
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">Единая
                            бонусная программа для всех туроператоров
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">Онлайн
                            доступ к заявкам на сайте ТО с момента бронирования
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">
                            Максимальные комиссии независимо от объемов продаж
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">
                            Бронирование в режиме <span class="cb-blue">24/7</span> в одном личном кабинете
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-l-20 wsl-p-r-50 wsl-p-y-10">
                            Электронный документооброт и самостоятельная автоматизированная выписка документов на вылет
                            агентством
                        </div>
                        <div class="wsl-text-center wsl-p-l-20 wsl-p-r-50 wsl-p-b-5 wsl-m-t-20">
                            <a class="cb-btn-blue wsl-inline-block z-depth-3 wsl-m-t-60" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                        </div>
                    </div>
                </div>

            </div>

            <div class="wsl-w-100 wsl-h-100 wsl-relative wsl-hide-md wsl-hide-sm wsl-hide-xs">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/s03-bg1.jpg">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s03Bg2}`}"
                     style="
                 background: url('../assets/img/s03-bg2.png');
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top right;
                    top: 0; left: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 16.45%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">03
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Бронирование туров</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s03Bg3}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 21.73%; left: 3.15%; width: 33.4%; height: 65.5%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-30" style="line-height: 1.2; padding-left: 9.15%;">
                            <div>
                                <span class="Oswald-Light cb-cyan t48">Высокотехнологичная </span>
                                <span class="Oswald-Light cb-blue t48">система бронирования туров</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs wsl-flex-middle-ng wsl-h-100" style="right: 0; top: 0;">
                    <div class="wsl-flex-column-bottom-ng">
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width cb-bg-blue"
                        >Моментальные автоматические оплаты туроператорам
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width"><span
                                class="cb-blue">100%</span> актуальность результатов с временем вылета и сборами
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">Поиск по
                            более чем <span class="cb-blue">200</span> туроператорам с понятным интерфейсом
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">
                            Интернет-эквайринг с рекордно низкой ставкой, в том числе с оплатой от заказчика
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">Единая
                            бонусная программа для всех туроператоров
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">Онлайн
                            доступ к заявкам на сайте ТО с момента бронирования
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">
                            Максимальные комиссии независимо от объемов продаж
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">
                            Бронирование в режиме <span class="cb-blue">24/7</span> в одном личном кабинете
                        </div>
                        <div class="Oswald-Light cb-white t24 wsl-p-x-40 wsl-p-b-5 wsl-m-y-8 sec-03-text-width">
                            Электронный документооброт и самостоятельная автоматизированная выписка документов на вылет
                            агентством
                        </div>
                        <div class="wsl-text-center wsl-p-x-40 wsl-p-b-5 wsl-m-t-20 sec-03-text-width">
                            <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-03',
  props: {
    s03Bg1: String,
    s03Bg2: String,
    s03Bg3: String
  }
}
</script>

<style scoped>

</style>
